<template>
  <div
    @click="selectCreate(item.to)"
    class="flex items-center p-8 mb-5 rounded-lg shadow-lg flex-1 md:mr-5 cursor-pointer"
  >
    <div class="flex flex-initial pr-5">
      <img :src="item.icon" class="w-16" alt="" />
    </div>
    <div class="flex-1 flex flex-col ">
      <div class="w-full flex text-xl font-bold ">{{ item.title }}</div>
      <div>{{ item.subtitle }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    item: {
      type: Object
    }
  },
  methods: {
    selectCreate(to) {
      this.$router.push({ path: to });
    }
  },
  computed: {
    ...mapState({
      create: state => state.surat.create
    })
  }
};
</script>
